module.exports = __webpack_public_path__ + "static/img/icon1.4716d270.png";